export default function VideoPlayer({ src, poster, title = "Watch the trailer" }) {
  if (!src) return null;
  return (
    <div className="my-10" data-testid="video-player">
      <div className="label text-pfc-gold mb-3">▶ {title}</div>
      <video
        controls
        preload="metadata"
        poster={poster}
        className="w-full bg-black"
        style={{ borderRadius: 12, maxHeight: "70vh" }}
      >
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}
